import { invalidLastNameErrorMap } from './errorDictionary';
import { isValidName } from '../../utils/fieldValidators';
import useValidators from './useValidators';
function useValidLastName() {
    const errorMessageMap = [invalidLastNameErrorMap];
    const validators = [isValidName];
    return useValidators(errorMessageMap, validators);
}
export default useValidLastName;
